import React from 'react';
import { Grid, TextField } from "@mui/material";

const FiltroCierreMensual = ({ filtroMes, setFiltroMes, filtroVersion, setFiltroVersion }) => {
    return (
        <Grid item xs={12} sm={8} md={9} lg={9} xl={9} className="alignRight" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, justifyContent: { xs: 'flex-start', sm: 'flex-end' }, alignItems: { xs: 'stretch', sm: 'center' }, width: '100%' }}>
            <TextField
                label="Filtrar por Mes"
                type="month"
                InputLabelProps={{ shrink: true }}
                value={filtroMes}
                onChange={(e) => setFiltroMes(e.target.value)}
                size="small"
                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 200 }, bgcolor: 'white' }}
            />
            <TextField
                label="Filtrar por Versión"
                variant="outlined"
                value={filtroVersion}
                onChange={(e) => setFiltroVersion(e.target.value)}
                size="small"
                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 200 }, bgcolor: 'white' }}
            />
        </Grid>
    );
};

export default FiltroCierreMensual;
